import { render, staticRenderFns } from "./WebhookSubscriptionForm.vue?vue&type=template&id=64951ea2"
import script from "./WebhookSubscriptionForm.vue?vue&type=script&lang=js"
export * from "./WebhookSubscriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports